import { ReactElement, useEffect, useRef, useState } from 'react';

import { Wave } from './Wave';
import { CanvasContext } from '../hooks/useCanvas';
import { useResponsiveSize } from '../hooks/useResponsiveSize';

export const Canvas = (): ReactElement => {
    const { width } = useResponsiveSize();

    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const [context, setContext] = useState<
        CanvasRenderingContext2D | undefined
    >();

    useEffect(() => {
        const ctx = canvasRef?.current?.getContext('2d');

        if (ctx) {
            setContext(ctx);
        }
    }, []);

    return (
        <CanvasContext.Provider value={{ context }}>
            <canvas id='canvas' ref={canvasRef} width={width}
                height={220} />
            <Wave />
        </CanvasContext.Provider>
    );
};
